/*
These functions make sure WordPress
and Foundation play nice together.
*/

// HERO VIDEO VARS
// var min_w = 300; 
// var vid_w_orig;
// var vid_h_orig;

jQuery(document).ready(function() { // DOM

  // Detect Internet Explorer
  detect_IE();

  // Detect Firefox
  detect_Firefox();

  // Detect Native Android Browser
  detect_native_android_browser();

  // Detect Opera
  detect_OP();

  // Apple Device Detect
  device_detect();

  // Remove empty P tags created by WP inside of Accordion and Orbit
  jQuery('.accordion p:empty, .orbit p:empty').remove();

	 // Makes sure last grid item floats left
	jQuery('.archive-grid .columns').last().addClass( 'end' );

	// Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
      jQuery(this).wrap("<div class='widescreen flex-video'/>");
    } else {
      jQuery(this).wrap("<div class='flex-video'/>");
    }
  });

  // Ajax Content
  // bind_ajax_links();

  // Initialize Masonry
  // isotope_masonry();

  // Hero Video init
  // vid_w_orig = parseInt(jQuery('.hero-video .responsive_video_container video').attr('width')); 
  // vid_h_orig = parseInt(jQuery('.hero-video .responsive_video_container video').attr('height'));   
  // resize_hero_video();

  // DD Slick init and value preparation
  // jQuery("selector...").ddslick({
  //   width:'100%',
  //   onSelected: function(selectedData){
  //     var str = selectedData.original.context.value;
  //     console.log(str);
  //   }
  // });

  // DD Slick reset dropdowns
  // jQuery('selector...').ddslick('select', {index: 1 });
  // jQuery('selector... .dd-selected-text').text('ORIGINAL TEXT');
  // jQuery('selector...').isotope({ filter: '*' });

  // Event Target Testing
  jQuery( document ).click(function(event) {
      // console.log(event.target);
  });

  // Mobile Menu Event
  jQuery('.toggle-menu').click(function(){
    jQuery('.vertical-mobile-menu-container').addClass('is-open');
    jQuery('body').addClass('overflow-mobile');
  });

  jQuery('.close').click(function(){
    jQuery('.vertical-mobile-menu-container').removeClass('is-open');
    jQuery('body').removeClass('overflow-mobile');
  });

  // Homepage Accordions always open

  jQuery('.ult-tabto-accordionItem').addClass('always');
  jQuery('.ult-tabto-accordionItem').click(function(){ 
    if (jQuery(this).hasClass('always')) {
      jQuery(this).toggleClass('always');
    }
  });

  // Read More About Us Menu Event
            //jQuery('.readmore-aboutus').click(function(event){
            //  jQuery(this).hide();
            //  jQuery('.hide-paragraph').toggleClass('active');
            //  console.log('Paragraph show!');
            //});

   // Configure/customize these variables.
   var showChar = 259;  // How many characters are shown by default
   var ellipsestext = "...";
   var moretext = "Read More";
   var lesstext = "Read less";
    

  jQuery('.aboutus-paragraph .wpb_wrapper').each(function() {
        var content = jQuery(this).html();
 
        if(content.length > showChar) {
 
            var c = content.substr(0, showChar);
            var h = content.substr(showChar, content.length - showChar);
 
            var html = c + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span><a href="" class="morelink button pink clear">' + moretext + '</a></span>';
 
            jQuery(this).html(html);
      }
 
    });
 
    jQuery(".morelink").click(function(){
        if(jQuery(this).hasClass("less")) {
            jQuery(this).removeClass("less");
            jQuery(this).html(moretext);
      } else {
          jQuery(this).addClass("less");
          jQuery(this).html(lesstext);
      }
      jQuery(this).parent().prev().toggle();
      jQuery(this).prev().find('.morecontent span').toggle();
      jQuery(this).prev().find('.moreellipses').toggle();
      //jQuery(this).prev().toggle();
      return false;
  });


  // Read More About Us Menu Event
  jQuery('.vc_row').click(function(){
    jQuery('.hide-paragraph ').removeClass('active');
    jQuery('.readmore-aboutus').show();
  //  console.log('Paragraph show!');
  });



  // Homepage - Header animation detection
   jQuery(window).bind("scroll", function(event) {        
   /* if(jQuery(window).scrollTop() >= 753) {
      jQuery('.header').addClass('sticky');
    } else {
      jQuery('.header').removeClass('sticky');
    }
    if(jQuery(window).scrollTop() >= 80) {
      jQuery('.title-homepage').addClass('dontshow');
      //jQuery('.feat_img').addClass('dontshow');
    } else {
      jQuery('.title-homepage').removeClass('dontshow');
      //jQuery('.feat_img').removeClass('dontshow');
    }

    */

    my_navigation_bar();

  });

  my_navigation_bar();

  // Window resize detection
  jQuery( window ).resize(function() {

    // Hero Video responsiveness
    // resize_hero_video();

    // Mobile breakpoint for equal height divs
    mobile_logo();

  });

  mobile_logo();

  // Clear Gravity Forms placeholder on click
  jQuery('.gform_wrapper ul li input').focus(function() {
      jQuery(this).data('placeholder', jQuery(this).attr('placeholder')).attr('placeholder', '');
  }).blur(function() {
      jQuery(this).attr('placeholder', jQuery(this).data('placeholder'));
  });

}); 

function mobile_logo() {
  if(jQuery(window).width() <= 414) {
       jQuery('body').addClass('mobile');
     } else {
       jQuery('body').removeClass('mobile');
     }
}

function my_navigation_bar() {

    var window_height = jQuery(window).height();
    var element_height = 250;
    var element_title_height = jQuery(".title-homepage").height();
    var current_scroll_position = jQuery(window).scrollTop();
    var element_calc = (window_height - element_height) + 120;
    var element_calc_title = (window_height - element_title_height);

    if(jQuery('body').hasClass('mobile')) {
      element_calc = 10;
      element_calc_title = 10;
    } else {
      
    }

    //console.log('Element_calc: ' +element_calc);
    //console.log('Window_height: ' +window_height);
    //console.log(current_scroll_position);
    
    if(current_scroll_position >= element_calc) {
      jQuery('.header').addClass('sticky');
    } else {
      jQuery('.header').removeClass('sticky');
    }

    if(current_scroll_position >= element_calc_title) {
      jQuery('.title-homepage').addClass('dontshow');
    } else {
      jQuery('.title-homepage').removeClass('dontshow');
    }

}

// Detect Native Android Browser
function detect_native_android_browser() {
  var ua = navigator.userAgent;
  var is_native_android = ((ua.indexOf('Mozilla/5.0') > -1 && ua.indexOf('Android ') > -1 && ua.indexOf('AppleWebKit') > -1) && (ua.indexOf('Version') > -1));
  var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  if(is_native_android == true && isChrome == false) {
    if (window.location.href !== "http://okeeffemccann.wpengine.com/browser-overload/") {
      window.location="/browser-overload/";
    }
  }
}

// Detect Internet Explorer
function detect_IE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
    var trident = ua.indexOf('Trident/');
    if (msie > 0) {
      if (window.location.href !== "http://okeeffemccann.wpengine.com/browser-overload/") {
        window.location="/browser-overload/";
      }
    }
    if (trident > 0) {
        // IE 11 (or newer) => return version number
        var rv = ua.indexOf('rv:');
        jQuery('body').addClass('ie-11-or-newer');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }
    // other browser
    return false;
}

// Detect Firefox
function detect_Firefox() {
    var isFF = !!navigator.userAgent.match(/firefox/i);
    if (isFF === true) {
        // IE 10 or older => return version number
        jQuery('body').addClass('firefox');
    }
    // other browser
    return false;
}

// Detect Opera
function detect_OP() {
    var isOpera = !!window.opera || /opera|opr/i.test(navigator.userAgent);
    if (isOpera === true) {
        // IE 10 or older => return version number
        jQuery('body').addClass('opera');
    }
    // other browser
    return false;
}

// Apple Device Detect
function device_detect() {
  var iOS = ['iPad', 'iPhone', 'iPod'].indexOf(navigator.platform) >= 0;
  if(iOS === true) {
    jQuery('body').addClass('apple-device');
  } 
}

// Inline SVG replacement
function inline_svg_replacement() {
    jQuery('img.svg').each(function(){
      var $img = jQuery(this);
      var imgID = $img.attr('id');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');

      jQuery.get(imgURL, function(data) {
          // Get the SVG tag, ignore the rest
          var $svg = jQuery(data).find('svg');

          // Add replaced image's ID to the new SVG
          if(typeof imgID !== 'undefined') {
              $svg = $svg.attr('id', imgID);
          }
          // Add replaced image's classes to the new SVG
          if(typeof imgClass !== 'undefined') {
              $svg = $svg.attr('class', imgClass+' replaced-svg');
          }

          // Remove any invalid XML tags as per http://validator.w3.org
          $svg = $svg.removeAttr('xmlns:a');

          // Replace image with new SVG
          $img.replaceWith($svg);

      }, 'xml');
  });
}

// Items in Viewport
function items_in_viewport(item_selector) {

  if(item_selector == ".outline_svg") {
    animationIn = 'inViewPort';
    animationOut = '';
  } 

  if(item_selector == ".grid-item .article-title") {
    animationIn = 'slideInUp';
    animationOut = 'slideOutDown';
  }

  if(jQuery(item_selector).length > 0) {

    if(item_selector === ".video-demo .html5vid iframe") {

        var iframe = jQuery(item_selector);
        var player = new Vimeo.Player(iframe);

        jQuery(item_selector+":above-the-top").each(function(index) {
          player.pause();
        });

        jQuery(item_selector+":in-viewport").each(function(index) {
          player.play();
        });

        jQuery(item_selector+":below-the-fold").each(function(index) {
          player.pause();
        });

    } else {

        jQuery(item_selector+":above-the-top").each(function(index) {
            // jQuery(this).removeClass(animationIn);
            // jQuery(this).addClass(animationOut);
        });

        jQuery(item_selector+":in-viewport").each(function(index) {
            jQuery(this).removeClass(animationOut);
            jQuery(this).addClass(animationIn);
        });

        jQuery(item_selector+":below-the-fold").each(function(index) {
            // jQuery(this).removeClass(animationIn);
            // jQuery(this).addClass(animationOut);
        });

    }

  }

}


// Binds links in selector to call content via ajax
function bind_ajax_links() {

  var selector = ".menu-contents ul li a, header.article-header h2 a, .sidebar .widget ul li a, .story-list a, .article-title-bottom a";

  jQuery(selector).unbind( "click" );
  jQuery(selector).click(function(event){

    event.preventDefault();

    jQuery("#epic-nav").addClass('activated');

    jQuery('.menu-contents ul li').removeClass('current-menu-item');
    jQuery(this).parent().addClass('current-menu-item');

    var linktoload = jQuery(this).attr('href');

    // Verify String
    if (typeof linktoload !== typeof undefined && linktoload !== false) {
      // Redirects
      external_redirect(linktoload);
      // Fetch content
      load_content(linktoload);
    }
  });

}

// Ajax load the content
function load_content(linktoload) {

  // Scroll to top of page
  jQuery('html, body').animate({scrollTop:0}, 1000);

  // Loading animation
  jQuery("#ajax-content").removeClass('visible');
  jQuery("#ajax-content").addClass('loading');

  jQuery('.loader_vertbar').addClass('loading');

  setTimeout(function(){

    jQuery.get(linktoload)
      .success(function(data, textStatus, jqXHR){

        var data = data.replace('<body', '<body><div id="body"').replace('</body>', '</div></body>').replace('<style type="text/css" data-type="vc_shortcodes-custom-css"','<style type="text/css" id="vc_shortcodes-custom-css" data-type="vc_shortcodes-custom-css"').replace('<div id="ajax-content" ','<div id="ajax-content" ');

        var vc_css = jQuery(data).filter('#vc_shortcodes-custom-css');
        var body = jQuery(data).filter('#body');
        var child_nodes = body[0].childNodes;

      var ajax_html = '';
      for (var i = 0; i < child_nodes.length; i++) {
        var child_node_content = child_nodes[i].innerHTML;
        if(child_node_content != undefined && child_node_content != '' && child_node_content.indexOf('skrollr-body') > -1) {
          ajax_html = child_node_content; 
            // console.log(ajax_html);
        }       
      }

        var linktoload_classes = body[0].className;

        jQuery('body').removeClass();
        jQuery('body').addClass(linktoload_classes);

        jQuery('*[data-type="vc_shortcodes-custom-css"]').remove();

        if(vc_css[0] != undefined) {
          jQuery('head').append(vc_css[0]);
      }
        
        close_epic_menu();

      jQuery( "#ajax-content" ).load( linktoload + " #ajax-content > *",function(){

        // jQuery( ".landing-page-menu" ).load( linktoload + " .landing-page-menu > *",function(){ /* ... */ });
        // jQuery( ".download-link" ).load( linktoload + " .download-link > *",function(){ /* ... */ });

        // skrollr_init(); 
        epic_title_size();
        bind_ajax_links();
        isotope_masonry();
        jQuery(window).trigger('resize');
        
        jQuery('.loader_vertbar').removeClass('loading');
        jQuery('.loader_vertbar').addClass('loaded');

        setTimeout(function(){

          jQuery("#ajax-content").removeClass('loading');
          jQuery("#ajax-content").addClass('loaded');
    
          jQuery(window).trigger('resize');

          jQuery('.loader_vertbar').removeClass('loaded');

          jQuery("#ajax-content").removeClass('loaded');
          jQuery("#ajax-content").addClass('visible');

          jQuery("#content").addClass('visible');

        },350);
    
      });

      });

  },400);

}

// If if a link is not pointing to this domain, open in a new window
function external_redirect(linktoload) {
  var search_dev_domain = linktoload.search("volum8v2016.wpengine.com");
  var search_live_domain = linktoload.search("volum8.co");
  if((search_dev_domain > -1) || (search_live_domain > -1)) {
    // Local, okay to proceed
    history.pushState({}, '', linktoload);
  } else {
    // External, open window
    window.open(linktoload,'_blank');
    return false;
  }
}

// Detect Internet Explorer
function detectIE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
    var trident = ua.indexOf('Trident/');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }
    if (trident > 0) {
        // IE 11 (or newer) => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }
    // other browser
    return false;
}

// Load Content via Popstate
function load_content_via_popstate() {
  load_content(window.location);
}

// Back and Forward Browser Support
// if(detectIE()) { } else {
  // window.addEventListener('popstate', function(event) {
    // console.log('popstate fired!');
    // load_content(window.location);
  // });
// }

// Activates grid based masonry layout
function isotope_masonry() {
  jQuery('.grid').isotope({
    itemSelector: '.grid-item',
    percentPosition:true,
    masonry: { 
    columnWidth: '.grid-sizer'
    }
  }); 
  jQuery('.grid-item').click(function(event){
    var this_grid_item = jQuery(this);
    var link_to_go_to = this_grid_item.find('a').attr('href');
    external_redirect(link_to_go_to);
    load_content(link_to_go_to);
  }); 
  jQuery('.filter-button-group').on( 'click', 'button', function() {
    var filterValue = jQuery(this).attr('data-filter');
    jQuery('.grid').isotope({ filter: filterValue });
  });
  setTimeout(function(){
    jQuery("#showallposts").click();
  },350);
}

// Hero Video init/resize
function resize_hero_video() {

    // set the video viewport to the window size
    jQuery('.responsive_video_container').width(jQuery(window).width());
    jQuery('.responsive_video_container').height(jQuery(window).height());

    // use largest scale factor of horizontal/vertical
    var scale_h = jQuery('.responsive_video_overflow').width() / vid_w_orig;
    var scale_v = jQuery('.responsive_video_overflow').height() / vid_h_orig;
    var scale = scale_h > scale_v ? scale_h : scale_v;

    // don't allow scaled width < minimum video width
    if (scale * vid_w_orig < min_w) {scale = min_w / vid_w_orig;}

    // now scale the video
    jQuery('.responsive_video_container video').width(scale * vid_w_orig);
    jQuery('.responsive_video_container video').height(scale * vid_h_orig);

    // and center it by scrolling the video viewport
    jQuery('.responsive_video_container').scrollLeft((jQuery('.responsive_video_container video').width() - jQuery(window).width()) / 2);
    jQuery('.responsive_video_container').scrollTop((jQuery('.responsive_video_container video').height() - jQuery(window).height()) / 2);

}

// Equal column height
equalheight = function(container){

  var currentTallest = 0,
    currentRowStart = 0,
    rowDivs = new Array(),
    el,
    topPosition = 0;

  jQuery(container).each(function() {

    el = jQuery(this);
    jQuery(el).height('auto');
    topPostion = el.position().top;

    if (currentRowStart != topPostion) {
      for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
      rowDivs.length = 0; // empty the array
      currentRowStart = topPostion;
      currentTallest = el.height();
      rowDivs.push(el);
    } else {
      rowDivs.push(el);
      currentTallest = (currentTallest < el.height()) ? (el.height()) : (currentTallest);
    }

    for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
      rowDivs[currentDiv].height(currentTallest);
    }

  });
};

// Clear equal column height after (for mobile breakpoint)
function clearheight(container) {
    jQuery(container).each(function() {
    el = jQuery(this);
      jQuery(el).css('height','');
  });
}

// Show icon svg on menu
function iconmenushow() {
  jQuery( ".home-logo a" ).empty();
  jQuery( ".home-logo a" ).prepend("<div class='logo-svg'><img class='svg' src='/wp-content/uploads/2016/09/logo.svg' alt='Logo'></div>");
  jQuery( ".about-us a" ).prepend("<div class='icon-menu-svg about-us'><img class='svg' src='/wp-content/uploads/2016/09/icon-about-us.svg' alt='About Us'></div>");
  jQuery( ".our-services a" ).prepend("<div class='icon-menu-svg our-services'><img class='svg' src='/wp-content/uploads/2016/10/icon-our-services.svg' alt='Our Services'></div>");
  jQuery( ".news a" ).prepend("<div class='icon-menu-svg news'><img class='svg' src='/wp-content/uploads/2016/09/icon-news.svg' alt='News and Insight'></div>");
  jQuery( ".contact a" ).prepend("<div class='icon-menu-svg contact'><img class='svg' src='/wp-content/uploads/2016/09/icon-contact-us.svg' alt='Contact Us'></div>");
}

// Show div inside square-frame-blog
function squareframe() {
  jQuery( ".square-frame-blog" ).prepend( "<div class='square-frame square-frame-top-center'></div><div class='square-frame square-frame-top-left-side'></div><div class='square-frame square-frame-top-right-side'></div>" );
  jQuery( ".square-frame-logo" ).prepend( "<div class='square-frame square-frame-bottom-center'></div><div class='square-frame square-frame-bottom-left-side'></div><div class='square-frame square-frame-bottom-right-side'></div>" );
  jQuery( ".square-frame-left" ).prepend( "<div class='square-frame square-frame-top-left'></div><div class='square-frame square-frame-tall-left'></div><div class='square-frame square-frame-bottom-left'></div>" );
  jQuery( ".square-frame-left-small" ).prepend( "<div class='square-frame square-frame-top-left-small'></div><div class='square-frame square-frame-tall-left-small'></div><div class='square-frame square-frame-bottom-left-small'></div>" );
  jQuery( ".hr-square" ).prepend( "<div class='square-frame hr-square-bottom-left'></div>" );
  jQuery( ".hr-square-center" ).prepend( "<div class='square-frame hr-square-bottom-center'></div>" );
  //jQuery( ".blog .first-page-blog article:nth-child(2) .inner-article, .archive .first-page-blog article:nth-child(2) .inner-article, .blog article:first-child .inner-article, .archive article:first-child .inner-article" ).prepend( "<div class='square-frame square-frame-top-center'></div><div class='square-frame square-frame-top-left-side'></div><div class='square-frame square-frame-top-right-side'></div>" );
  jQuery( ".single article .vc_row:first-child p:first-child" ).prepend( "<div class='square-blog-single'></div>" );
}

// Grid item SVG animation
function iconmenu_svg_animation() {

  var path_selector = '.replaced-svg path, .replaced-svg polygon, .replaced-svg rect, .replaced-svg circle, .replaced-svg polyline';

  jQuery("#menu-main-menu li a").hover(function(event) {

  //jQuery('.icon-menu-svg').hover(function(event) {
    var svg_found = jQuery(this).find(path_selector);
    if(svg_found.length > 0) {
      TweenLite.to(svg_found, 0, {drawSVG:"0% 0%"});
      setTimeout(function(){
        TweenLite.to(svg_found, 1.5, {drawSVG:true});
      },200);
    }
  },function(event){
      var svg_found = jQuery(this).find(path_selector);
      if(svg_found.length > 0) {
        TweenLite.to(svg_found, 0.5, {drawSVG:true});
      }
  });

}

// Content stroke
jQuery(function(){
  
  // console.log('ready..');
  squareframe();
  iconmenushow();
  inline_svg_replacement();
  iconmenu_svg_animation();
  setTimeout(function(e){


  // When page is ready
  items_in_viewport('.home-logo a');
  items_in_viewport('.square-frame-logo');
  items_in_viewport('.square-frame-blog');
  items_in_viewport('.square-frame-left');
  items_in_viewport('.square-frame-left-small');
  items_in_viewport('.hr-square');
  items_in_viewport('.hr-square-center');
  //items_in_viewport('.archive article:first-child .inner-article');   
  //items_in_viewport('.blog article:first-child .inner-article');
  //items_in_viewport('.archive .first-page-blog article:nth-child(2) .inner-article');   
  //items_in_viewport('.blog .first-page-blog article:nth-child(2) .inner-article');
  items_in_viewport('.single article .vc_row:first-child p:first-child');    

  // Scroll Events & Viewport Connection
  jQuery(window).bind("scroll", function(event) {
    items_in_viewport('.home-logo a');
    items_in_viewport('.square-frame-logo');   
    items_in_viewport('.square-frame-blog');
    items_in_viewport('.square-frame-left');
    items_in_viewport('.square-frame-left-small');
    items_in_viewport('.hr-square');
    items_in_viewport('.hr-square-center');
    //items_in_viewport('.archive article:first-child .inner-article');   
    //items_in_viewport('.blog article:first-child .inner-article');
    //items_in_viewport('.archive .first-page-blog article:nth-child(2) .inner-article');   
    //items_in_viewport('.blog .first-page-blog article:nth-child(2) .inner-article');
    items_in_viewport('.single article .vc_row:first-child p:first-child');    
  });  

  },500);
  
  //flexibility(jQuery('.ie-11-or-newer '));


}); // DOM

function stroke_animate(animate_element) {
  
  // Square Frame Logo
  if((animate_element === '.square-frame-logo') && (!jQuery('.header').hasClass('sticky'))) {
    jQuery(animate_element+' .square-frame-bottom-left-side').addClass('draw');
    setTimeout(function(){
      jQuery(animate_element+' .square-frame-bottom-center').addClass('draw');
    },1000);
    setTimeout(function(){
      jQuery(animate_element+' .square-frame-bottom-right-side').addClass('draw');
    },2000);
  }

  if((animate_element === '.square-frame-logo') && (jQuery('.header').hasClass('sticky'))) { 
    jQuery(animate_element+' .square-frame-bottom-left-side').addClass('draw');
    jQuery(animate_element+' .square-frame-bottom-center').addClass('draw');
    jQuery(animate_element+' .square-frame-bottom-right-side').addClass('draw');
  }

  // Square Frame Blog
  if(animate_element === '.square-frame-blog') {
    jQuery(animate_element+' .square-frame-top-center').addClass('draw');
    setTimeout(function(){
      jQuery(animate_element+' .square-frame-top-left-side').addClass('draw');
      jQuery(animate_element+' .square-frame-top-right-side').addClass('draw');
    },1000);
  }
  
  // Square Frame Left
  if(animate_element === '.square-frame-left') {
    jQuery(animate_element+' .square-frame-top-left').addClass('draw');
    setTimeout(function(){
      jQuery(animate_element+' .square-frame-tall-left').addClass('draw');
      setTimeout(function(){
        jQuery(animate_element+' .square-frame-bottom-left').addClass('draw');
      },1000);
    },1000);  
  }

   // Square Frame Left Small
  if(animate_element === '.square-frame-left-small') {
    jQuery(animate_element+' .square-frame-top-left-small').addClass('draw');
    setTimeout(function(){
      jQuery(animate_element+' .square-frame-tall-left-small').addClass('draw');
      setTimeout(function(){
        jQuery(animate_element+' .square-frame-bottom-left-small').addClass('draw');
      },1000);
    },1000);  
  }

  // Square Frame Blog-Home
  if(animate_element === '.archive .first-page-blog article:nth-child(2) .inner-article' || animate_element === '.blog .first-page-blog article:nth-child(2) .inner-article' || animate_element === '.blog article:first-child .inner-article' || animate_element === '.blog article:first-child .inner-article') {
    jQuery(animate_element+' .square-frame-top-center').addClass('draw');
    setTimeout(function(){
      jQuery(animate_element+' .square-frame-top-left-side').addClass('draw');
      jQuery(animate_element+' .square-frame-top-right-side').addClass('draw');
    },1000);
  }

  // Hr Frame Left
  if(animate_element === '.hr-square') {
    jQuery(animate_element+' .hr-square-bottom-left').addClass('draw');  
  }

  // Hr Frame Center
  if(animate_element === '.hr-square-center') {
    jQuery(animate_element+' .hr-square-bottom-center').addClass('draw');  
  }
  
}

// Items in Viewport

function items_in_viewport(item_selector) {
 
  if(jQuery(item_selector).length > 0) {

    jQuery(item_selector+":in-viewport").each(function(index) {
      stroke_animate(item_selector);
    });
    
  }
  
}